/* eslint-disable @typescript-eslint/no-explicit-any*/
import { Form, Select } from "antd";

export function FormSelect({
  id,
  name = "",
  label = "",
  options,
  placeholder = "Select an option",
  required,
  widthSize = "large",
  rules,
  mode,
  ...rest
}: any) {
  const widthPercentage: string = (() => {
    switch (widthSize.toLowerCase()) {
      case "medium":
        return "75%";
      case "small":
        return "50%";
      default:
        return "100%";
    }
  })();

  const normalizedRules = (rules ?? []).map((rule: any) => ({
    ...rule,
    required:
      typeof rule.required === "string"
        ? rule.required.toLowerCase() === "true"
        : rule.required,
  }));

  return (
    <Form.Item
      label={label}
      name={name}
      rules={normalizedRules}
      layout="vertical"
    >
      <Select
        showSearch
        optionFilterProp="label"
        placeholder={placeholder}
        options={options}
        {...rest}
        style={{ width: widthPercentage }}
        mode={mode}
      />
    </Form.Item>
  );
}
